{
  "version": 1,
  "asset_id": "578837a7-3dd6-4bcc-a86e-e39b4918cc9a",
  "project_id": "9f205a2e-8c62-436c-9ba0-eb8567773752",
  "url": "/__l5e/assets-v1/578837a7-3dd6-4bcc-a86e-e39b4918cc9a/southend-drone-poster-640.jpg",
  "r2_key": "a/v1/9f205a2e-8c62-436c-9ba0-eb8567773752/578837a7-3dd6-4bcc-a86e-e39b4918cc9a/southend-drone-poster-640.jpg",
  "original_filename": "southend-drone-poster-640.jpg",
  "size": 52468,
  "content_type": "image/jpeg",
  "created_at": "2026-07-22T22:52:18Z"
}
